var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfResultsStepCurrentEnd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 27.984,
    height: 27.984,
    viewBox: "0 0 27.984 27.984",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Step marker"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9922 0.638672C21.3669 0.638764 27.3457 6.61743 27.3457 13.9922C27.3456 21.3669 21.3669 27.3456 13.9922 27.3457C6.61743 27.3457 0.638764 21.3669 0.638672 13.9922C0.638672 6.61737 6.61737 0.638672 13.9922 0.638672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9922 0.638672C21.3669 0.638764 27.3457 6.61743 27.3457 13.9922C27.3456 21.3669 21.3669 27.3456 13.9922 27.3457C6.61743 27.3457 0.638764 21.3669 0.638672 13.9922C0.638672 6.61737 6.61737 0.638672 13.9922 0.638672Z",
    stroke: "#E07409",
    strokeWidth: 1.27745
  }), /*#__PURE__*/React.createElement("g", {
    id: "Active step dot",
    filter: "url(#filter0_d_0_4)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.992,
    cy: 13.992,
    r: 5,
    fill: "url(#paint0_linear_0_4)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_0_4",
    x: 5.85283,
    y: 6.89922,
    width: 16.2784,
    height: 16.2784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.0464
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5696
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.901961 0 0 0 0 0.490196 0 0 0 0 0.00784314 0 0 0 0.58 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_4"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_4",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_4",
    x1: 8.99202,
    y1: 13.992,
    x2: 17.2141,
    y2: 14.0256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E07409"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA44E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfResultsStepCurrentEnd);
export default __webpack_public_path__ + "static/media/cf-results-step-current-end.a1e9a85f33a2428419ff49c213395866.svg";
export { ForwardRef as ReactComponent };